export default __webpack_public_path__ + "static/media/wrongIcon.9804d828.svg";